class Settings {
  constructor () {
    this._current_tab = 0;
    this._is_valid = true;
  }

  get current_tab () {
    return this._current_tab;
  }

  get is_valid () {
    return this._is_valid;
  }


  set current_tab (value) {
    this._current_tab = value;
  }

  set is_valid (value) {
    this._is_valid = value;
  }

}

export default Settings;
